import styled from "styled-components";

import LoginBackground from "../../assets/images/login-background.png";
/**
 * Full-viewport login shell: hero background + subtle grain overlay.
 * Foreground layout uses Tailwind in `authentication/index.js`.
 */
export default styled.div`
  position: relative;
  isolation: isolate;
  display: flex;
  min-height: 100vh;
  min-height: 100dvh;
  flex-direction: column;
  background-color: #0d5c52;
  background-image: url("${LoginBackground}");
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  background-attachment: fixed;

  &::before {
    content: "";
    position: fixed;
    inset: 0;
    z-index: 0;
    pointer-events: none;
    opacity: 0.14;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E");
  }

  .login-z {
    position: relative;
    z-index: 1;
  }
`;
